import _ from '../../../../utils/lodash';

export function handleButtonClicks(row, position) {
  const { getValue, setValue } = this.props;
  const stateOfButtons = _.cloneDeep(getValue()) || {};
  const currentButtonRowState = _.cloneDeep(stateOfButtons[row]) || {};

  if (stateOfButtons[row] && stateOfButtons[row][position]) {
    delete stateOfButtons[row][position];
    if (Object.keys(stateOfButtons[row]).length <= 0) {
      delete stateOfButtons[row];
      if (Object.keys(stateOfButtons).length <= 0) {
        // If nothing is selected, set the value to undefined (default in formsy)
        return setValue(undefined);
      }
    }
    return setValue({
      ...stateOfButtons,
    });
  }
  return setValue({
    ...stateOfButtons,
    [row]: {
      ...currentButtonRowState,
      [position]: true,
    },
  });
}
